/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Account API
 * This API is for managing Accounts, Organizations and Workspaces.
 * OpenAPI spec version: 1.4.2
 */

/**
 * Type of the Account
 */
export type AccountEntityType = typeof AccountEntityType[keyof typeof AccountEntityType];


export const AccountEntityType = {
  ADVERTISER: 'ADVERTISER',
  BROKER: 'BROKER',
  SUPPLIER: 'SUPPLIER',
  KAZAAR: 'KAZAAR',
} as const;
